import { TableHead, TableRow } from "@material-ui/core";
import React from "react";
import StyledTableCell from "../../../styles/tableCell";

export default function TableHeadSells({ sellsByUser, globalSells, showSite }) {
  return (
    <TableHead>
      <TableRow
        style={{
          borderBottom: "0.5px solid gray",
        }}
      >
        {!globalSells && <StyledTableCell align="left"></StyledTableCell>}
        {showSite && <StyledTableCell>Sucursal</StyledTableCell>}
        <StyledTableCell align="center">Tipo de producto</StyledTableCell>

        <StyledTableCell align="center">Detalle</StyledTableCell>

        <StyledTableCell align="center">
          Subcat/IMEI/ICCID/Pend.pago
        </StyledTableCell>

        <StyledTableCell align="center">Código de barras</StyledTableCell>
        <StyledTableCell align="center">Precio de venta</StyledTableCell>
        {!globalSells && (
          <StyledTableCell align="center">Descuento</StyledTableCell>
        )}
        {sellsByUser && (
          <StyledTableCell align="center">Forma de pago</StyledTableCell>
        )}
        {!sellsByUser && (
          <StyledTableCell align="center">Vendedor</StyledTableCell>
        )}
        <StyledTableCell align="center">Fecha de venta</StyledTableCell>
        {globalSells && <StyledTableCell align="center">Lote</StyledTableCell>}
        {!globalSells && (
          <StyledTableCell align="center">Factura generada</StyledTableCell>
        )}
        {globalSells && (
          <StyledTableCell align="center">Tracking</StyledTableCell>
        )}
      </TableRow>
    </TableHead>
  );
}
